import { useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { NSButtonBlue } from 'namirasoft-site-react';
import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccountLayout } from "../AccountLayout";
import { NSSection, NSSpace, NSSpaceSizeType, NSBoxSensitive } from "namirasoft-site-react";
import { AccountRoutes } from "../AccountRoutes";
import { NSPanel } from 'namirasoft-site-react';

interface PasswordNewPageProps extends NSARouterMakerResult
{ }

function PasswordNewPage(props: PasswordNewPageProps) 
{
	const NSBoxSensitive_NewPassword = useRef<NSBoxSensitive>(null);
	const NSBoxSensitive_Rep_Password = useRef<NSBoxSensitive>(null);
	const params = useParams();

	function onApply(onFinished: () => void)
	{
		try
		{
			let user_id: string = params.user_id ?? "";
			let hash: string = params.hash ?? "";
			let pass_new: string = NSBoxSensitive_NewPassword.current?.getValue() ?? "";
			let pass_rep: string = NSBoxSensitive_Rep_Password.current?.getValue() ?? "";
			if (pass_new === pass_rep)
			{
				props.account.server.password.New({ user_id, hash, pass_new, pass_rep }).then(() =>
				{
					props.notifier.onSuccess("The request was made successfully.");
					props.notifier.onSuccess("Redirecting ...", 2000);
					setTimeout(() =>
					{
						props.url.redirect(AccountRoutes.Login, {});
						onFinished();
					}, 2000);
				}).catch(onFinished);
			}
			else
				throw new Error("Passwords do not match");
		} catch (error)
		{
			props.notifier.onError(error as Error);
			onFinished();
		}
	}

	return (
		<AccountLayout {...props}
			action={{ title: 'New Password', description: 'Please enter your new password.', menus: {} }}
		>
			<NSSection>
				<NSPanel>
					<NSBoxSensitive
						ref={NSBoxSensitive_NewPassword}
						title="New Password"
						required={true}
						placeholder="Please enter your new password"
					/>
					<NSBoxSensitive
						ref={NSBoxSensitive_Rep_Password}
						title="Confirm New Password"
						required={true}
						placeholder="Please enter your new password again"
					/>
				</NSPanel>
				<NSSpace size={NSSpaceSizeType.SMALL}></NSSpace>
				<NSButtonBlue title="Apply" onClick={{
					action: (onFinshed) =>
					{
						onApply(onFinshed);
					}
				}} />
				<NSSpace size={NSSpaceSizeType.SMALL}></NSSpace>
				<Link to={props.url.getLink(AccountRoutes.Login, [])} className="nsa-font-16-bold nsa-color-blue">Back to Login</Link>
			</NSSection>
		</AccountLayout>
	);
}

export default PasswordNewPage;